import { useState } from 'react';

import { uuid } from '@/util';

import BaseInputContext from './context';
import type { VBaseInputContextValue } from './type';

const VBaseInputContextProvider = ({
  children,
  size,
}: React.PropsWithChildren<Pick<VBaseInputContextValue, 'size'>>) => {
  const [id, setId] = useState<VBaseInputContextValue['id']>(
    `v-input-${uuid()}`,
  );
  const [required, setRequired] =
    useState<VBaseInputContextValue['required']>();
  const [status, setStatus] = useState<VBaseInputContextValue['status']>({
    disabled: false,
    focused: false,
    valid: null,
    readOnly: false,
  });

  return (
    <BaseInputContext.Provider
      value={{
        id,
        required,
        size,
        status,

        setId,
        setRequired,
        setStatus,
      }}
    >
      {children}
    </BaseInputContext.Provider>
  );
};

export default VBaseInputContextProvider;
